"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputScene = void 0;
const KHInputProviderController_1 = require("./KHInputProviderController");
const KHInputProviderKeyboard_1 = require("./KHInputProviderKeyboard");
class KHInputScene extends Phaser.Scene {
    constructor() {
        super("KHInputScene");
        this.registeredInputs = [];
        KHInputScene.SharedInput = this;
    }
    create() {
        this.controllerProviders = [
            new KHInputProviderController_1.KHInputProviderController(this, 0),
            new KHInputProviderController_1.KHInputProviderController(this, 1),
            new KHInputProviderController_1.KHInputProviderController(this, 2),
            new KHInputProviderController_1.KHInputProviderController(this, 3)
        ];
        this.keyboardProvider = new KHInputProviderKeyboard_1.KHInputProviderKeyboard(this);
        this.events.on('preupdate', (now, delta) => {
            this.updateInputs(now, delta);
        }, this);
    }
    updateInputs(now, delta) {
        for (let i = 0; i < this.controllerProviders.length; i++) {
            this.controllerProviders[i].update(now, delta);
        }
        this.keyboardProvider.update(now, delta);
        for (let i = 0; i < this.registeredInputs.length; i++) {
            this.registeredInputs[i].updateDerivedInput(now, delta);
        }
    }
    registerInput(input) {
        this.registeredInputs.push(input);
    }
}
exports.KHInputScene = KHInputScene;
